<template>
  <div class="add-to-cart">
    <button
      class="btn btn-action"
      id="customizer-add-to-cart-btn"
      @click="onAddToCart"
      :class="{disabled : !validCart}"
    >Add to Cart</button><!-- /.btn -->
  </div><!-- /.add-to-cart -->
</template>

<script>
import { mapActions, mapState } from "vuex"

export default {
  name: "AddToCart",
  computed: {
    ...mapState([
      "selectedOptions",
      "selectedVariant",
      "validCart",
      "cropData",
      "selectedPhoto",
      "quantitySelected",
      "selectedOrientation",
      "productType",
      "enableLowQualityImage",
      "from",
      "productTitle"
    ])
  },
  methods: {
    ...mapActions(["closeCustomizer"]),
    onAddToCart() {
      if (this.validCart) {
        let cropWidth = this.cropData.width - this.cropData.left
        let cropHeight = this.cropData.height - this.cropData.top

        let _imageLayers = [
          {
            Sequence: 1,
            LayerX: (-this.cropData.left).toString(),
            LayerY: (-this.cropData.top).toString(),
            LayerWidth: this.selectedPhoto.width,
            LayerHeight: this.selectedPhoto.height,
            Rotation: this.cropData.rotation,
            Url: this.selectedPhoto.imageUrl,
            Crop: {
              CropLeft: 0,
              CropTop: 0,
              CropWidth: cropWidth,
              CropHeight: cropHeight,
            },
            Row: 0,
            Column: 0,
          },
        ]

        // Line Item properties
        var properties = {
          _Width: cropWidth,
          _Height: cropHeight,
          _Flip: this.selectedOrientation,
          _CustomProductType: this.productType,
          _imageLayers,
          _customOptions: []
        }

        //filter out the unselected design options
        let optionsArr = Object.values(this.selectedOptions) // obj to arr
        let removeMaterialOptions = optionsArr.filter(option => !option.isMaterial)

        removeMaterialOptions.forEach((option) => {
          var customOption = null

          if (!option.optionCode) return;

          if (option.isStoreOption || option.isFilter) {
            properties["_"+option.groupName] = option.name
            if (option.isSize) {
              if (this.enableLowQualityImage && option.isLowRes) {
                properties._lowResolution = true;
              }
            }
          }
          else if (option.isDesignOption) {
            if (option.name === true) {
              customOption = {
                Code: option.optionCode,
                DisplayName: option.groupName
              }

              if (option.groupCode == 'DIGITALPROOF') {
                properties['Digital Proof'] = 'Yes'
              }
              else {
                if (option.noteRequired) {
                  customOption['Notes'] = option.notes
                  properties[option.groupName] = option.notes
                }
                else {
                  properties[option.groupName] = 'Yes'
                }
              }
            }
            else {
              if (option.groupCode == 'DIGITALPROOF') {
                properties['Digital Proof'] = 'No'
              }
              else {
                properties["_" + option.groupName] = 'No'
              }
            }
          }
          else {
            if (option.groupCode !== 'SIZE') {
              customOption = {
                Code: option.optionCode,
                DisplayName: option.groupName
              }
            }
            properties[option.groupName] = option.name
          }

          if (customOption) {
            properties._customOptions.push(customOption)
          }
        })

        const item = {
          id: this.selectedVariant.id,
          quantity: this.quantitySelected,
          properties: properties
        }

        if (this.from === 'embed') {
          const totalItems = localStorage.getItem('totalItems')
          let index = 1
          if (totalItems) {
            index = parseInt(totalItems) + 1
          }
          const keyOfItem = 'lineItem' + index
          item.title = this.productTitle + ' - ' + this.selectedVariant.size
          localStorage.setItem(keyOfItem, JSON.stringify(item))
          localStorage.setItem('totalItems', index)
        } else {
          document.dispatchEvent(new CustomEvent('customizer.ajaxCart', { detail: item }))
          this.closeCustomizer();
          this.$router.replace('/')
        }
      }
    }
  }
}
</script>
